export default __webpack_public_path__ + "images/0x2baec546a92ca3469f71b7a091f7df61e5569889.png";